<template>
  <UCard class="max-w-sm w-full">
    <template #header> Recupera la password </template>

    <UForm
      v-if="!submitted"
      :validate="validate"
      :state="user"
      class="space-y-4"
      @submit="onSubmit"
    >
      <UFormGroup label="Email" name="email">
        <UInput
          v-model="user.email"
          placeholder="you@example.com"
          icon="i-heroicons-envelope"
        />
      </UFormGroup>
      <UButton type="submit" :loading="is_submitting" :disabled="submitted">
        Recupera
      </UButton>
    </UForm>
    <div v-if="response">
      <UAlert
        v-if="response?.object?.not_active"
        icon="i-heroicons-command-line"
        color="orange"
        variant="soft"
        title="Attenzione"
      >
        <template #description>
          L'email <strong>{{ user.email }}</strong> non risulta ancora
          convalidata. Prima di procedere con il recupero della password devi
          confermare la tua email.
          <strong
            >Clicca sul link che ti abbiamo inviato all'indirizzo email</strong
          >.
        </template>
      </UAlert>

      <UAlert
        v-else
        icon="i-heroicons-command-line"
        color="primary"
        variant="soft"
        title="Controlla la tua casella di posta"
      >
        <template #description>
          Abbiamo inviato un'email all'indirizzo
          <strong>{{ user.email }}</strong> con le istruzioni per recuperare la
          tua password.
        </template>
      </UAlert>
    </div>
    <!--
    <template v-if="!cfChallenge" #footer>
      <div v-if="!cfChallenge" class="cf-turnstile" />
    </template>
    -->
  </UCard>
</template>

<script setup lang="ts">
import type { FormError, FormSubmitEvent } from "#ui/types";

const is_submitting = ref(false);
const submitted = ref(false);
const { forgotPassword } = useProfile();
const response = ref<{
  success: boolean;
  message?: string;
  object?: { not_active: boolean };
}>();
/*const cfChallenge = ref(false);
const {
  public: { cfTurnstileKey },
} = useRuntimeConfig();
*/
const validate = (user: any): FormError[] => {
  const errors = [];
  if (!user.email)
    errors.push({ path: "email", message: "Inserisci il tuo indirizzo email" });
  return errors;
};
const user = reactive({
  email: undefined,
});

definePageMeta({
  layout: "light",
});
/*
onMounted(() => {
  window._turnstileCb = function () {
    turnstile.render(".cf-turnstile", {
      sitekey: cfTurnstileKey,
      theme: "light",
      callback: function () {
        cfChallenge.value = true;
      },
    });
  };
  window._turnstileCb();
});
*/

const onSubmit = async (event: FormSubmitEvent<any>) => {
  /*if (!cfChallenge.value) {
    response.value = {
      success: false,
      message: "Completa la verifica anti-robot",
    };
    return;
  }*/
  is_submitting.value = true;
  response.value = await forgotPassword(event.data);
  is_submitting.value = false;
  submitted.value = true;
};
</script>
